import {
  ServiceIcon,
  PatientAccessLevel,
  ServiceTagsDataFragment,
} from '../../../generated/graphql';
import { SearchOption } from '../../components/SearchableCombobox';

export interface Practitioner {
  id: string;
  name: string;
  email: string;
  profileImageUrl?: string;
}

export interface PractitionerSearchOption extends SearchOption {
  practitioner: Practitioner;
}

export interface ServiceBuilderForm {
  isEnabled: boolean;
  isShownOnStorefront: boolean;
  name: string;
  serviceIcon: ServiceIcon;
  serviceIconColorUseCalendlyDefault: boolean;
  calendlyEventColor: string | null;
  slug: string;
  description: string;
  isPaid: boolean;
  price: number;
  isPriceLabelShown: boolean;
  duration: number;
  calendlyEventTypeUri: string | null;
  serviceTags: ServiceTagsDataFragment[];
  intakeFormAssessmentId: string;
  patientAccessLevel: PatientAccessLevel;
  practitioners: PractitionerSearchOption[]; // Use our extended type
  serviceSubmissionTitle?: string;
  serviceSubmissionBody?: string;
  serviceSubmissionRedirectUrl?: string;
}

export const MAX_NAME_LENGTH = 50;
export const MAX_DESCRIPTION_LENGTH = 600;
export const DEFAULT_SERVICE_SUBMISSION_TITLE = 'Thank you';
export const DEFAULT_SERVICE_SUBMISSION_BODY =
  'Your details are in good hands. We will carefully review your submission and will be ' +
  'in touch soon with your next steps.';

/**
 * Converts GraphQL provider user data to the Practitioner format
 */
export const convertProviderUserToPractitioner = (
  providerUser: any,
): Practitioner => {
  return {
    id: providerUser.id,
    name: providerUser.name,
    email: providerUser.email,
    profileImageUrl: providerUser.profileImageMedia?.url || '',
  };
};

/**
 * Converts GraphQL provider user data to SearchOption format
 * with additional practitioner data for the SearchableCombobox
 */
export const convertProviderUserToSearchOption = (
  providerUser: any,
): PractitionerSearchOption => {
  const practitioner = convertProviderUserToPractitioner(providerUser);
  return {
    value: practitioner.id,
    name: practitioner.name,
    email: practitioner.email,
    practitioner: practitioner,
  };
};
